import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { TargetIcon } from "./Logo";

const Footer = () => (
  <footer className="mt-10 bg-[#1f2a37] text-gray-300">
    <div className="max-w-3xl mx-auto px-5 py-8">
      <div className="flex items-center gap-3 mb-4">
        <TargetIcon size={34} />
        <span className="text-lg font-bold text-white">Morning Sunday Teer</span>
      </div>
      <p className="text-sm leading-relaxed text-gray-400 mb-5">
        Morning Sunday Teer is an informational website providing Shillong
        Morning Teer Results, Previous Results, Common Numbers, Dream Numbers,
        Target Numbers, House Ending Numbers and Morning Teer Calendar. Our goal
        is to provide fast, accurate and mobile-friendly Morning Teer
        information for visitors.
      </p>

      <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-sm mb-5">
        <Link to="/" className="hover:text-white transition-colors">Home</Link>
        <Link to="/common-numbers" className="hover:text-white transition-colors">Common Number</Link>
        <Link to="/dream-numbers" className="hover:text-white transition-colors">Dream Number</Link>
        <Link to="/previous-result" className="hover:text-white transition-colors">Previous Result</Link>
        <Link to="/about" className="hover:text-white transition-colors">About</Link>
        <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
        <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
        <Link to="/terms" className="hover:text-white transition-colors">Terms &amp; Conditions</Link>
      </div>

      <a
        href="mailto:support@morningsundayteerresult.com"
        className="inline-flex items-center gap-2 text-sm text-[#7fc2f5] hover:text-white transition-colors mb-5"
      >
        <Mail className="w-4 h-4" />
        support@morningsundayteerresult.com
      </a>

      <div className="pt-4 border-t border-gray-700 text-center text-xs text-gray-500">
        &copy; 2026 Morning Sunday Teer. All Rights Reserved.
      </div>
    </div>
  </footer>
);

export default Footer;
